import React from 'react';
import { Trans } from 'react-i18next';
import styled from 'styled-components';

import { showFlair } from 'helpers/flair';
import { Row, Title, PageWrapper, PageContainer } from './common-styles';
import { Loader } from './common';

const StyledIFrame = styled.iframe`
  border: 0;
  width: 100%;
  min-width: 320px;
  height: 700px;
`;
const SuccessWindow = ({ action }) => {
  const isApproved = !!action?.status?.isApproved;
  const schedulingLink = action?.schedulingRequests?.find(
    (z) => z?.active && !z?.claimed
  )?.schedulingLink;
  const hasCalendlyLink = action?.calendarMode === 'calendly' && !!schedulingLink;

  React.useEffect(() => {
    showFlair('confetti');
    showFlair('fireworks');
  }, []);
  return (
    <PageWrapper fullScreen={true}>
      <PageContainer>
        <Row className="center">
          <Title>
            {isApproved ? (
              <Trans i18nKey="showing.steps.success.approved">
                Your tour request has been approved!
              </Trans>
            ) : (
              <Trans i18nKey="showing.steps.success.submitted">
                Your request has been submitted
              </Trans>
            )}
          </Title>
        </Row>
        {isApproved && hasCalendlyLink ? (
          <Row className="center text-center">
            <Trans i18nKey="showing.steps.success.description.calendly">
              Please choose a time you'd like to visit this home.
            </Trans>
          </Row>
        ) : isApproved ? (
          <Row className="center text-center">
            <Trans i18nKey="showing.steps.success.description.approved">
              We look forward to your visit to this home.
            </Trans>
          </Row>
        ) : (
          <Row className="center text-center">
            <Trans i18nKey="showing.steps.success.description.submitted">
              We'll be in contact with you on the status of your request.
            </Trans>
          </Row>
        )}
        {hasCalendlyLink ? (
          <StyledIFrame
            border="0"
            allow="camera"
            src={schedulingLink}
            id="iFrame"
            width="100%"
            height="700px"
          />
        ) : (
          <Row className="center">
            <img style={{ maxWidth: '100%' }} src="/assets/confetti.gif" alt="" />
          </Row>
        )}
      </PageContainer>
    </PageWrapper>
  );
};

export default ({ action, handleActions, location, onClose, onDone, fetchInProgress, loading }) => {
  if (fetchInProgress || loading) {
    return <Loader />;
  }
  return (
    <SuccessWindow
      action={action}
      handleActions={handleActions}
      location={location}
      onClose={onClose}
      onDone={onDone}
    />
  );
};
